import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { iSucursal } from '../models/isucursalmodel'
import { iObjDocCobranza } from '../models/iDocumentosCobranza.model'
import { ImagenBase64 } from '../models/imagenBase64.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class DocumentosCobranzaService {

    constructor(private apiService: ApiService, private http: HttpClient) { }

    /***Servicios Documentos Cobranza******/

    getListDocumentoCobranza(limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_lista);
        return this.apiService.execGetQueryJson(`?limit=${limit}&offset=${offset}`);
    }
    
    getListDocumentosVarios(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_modalclase + 'documentos-varios');
        return this.apiService.execGetQueryJson('');
    }

    buscar(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_modalclase + 'buscar');
        return this.apiService.execGetQueryJson('');
    }

    insertarDocumentoCobranza(data: iObjDocCobranza): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_insertar);
        return this.apiService.executePostJson(data).pipe();
    }

    eliminarDocumentoCobranza(tipdoc: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_eliminar);
        return this.apiService.executeDeleteJson(`${tipdoc}`);
    }

    actualizarDocumentoCobranza(data: iObjDocCobranza): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_actualizar);
        return this.apiService.executePutJson(data).pipe();
    }

    obtenerDocumentoCobranza(tipdoc: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_obtener);
        return this.apiService.execGetQueryJson(`${tipdoc}`)
    }

    /***Servicios para Modal Nuevo******/
    /*Combo1**/
    getListDocumentoCobranzaClases(tipdoc: number, descri: string, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_modalclase);
        return this.apiService.execGetQueryJson(`${tipdoc}/clases?descri=${encodeURI(descri)}&limit=${limit}&offset=${offset}`);
    }
    /*Comb2**/
    getListClasesCodigos(tipdoc: number, clase: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_modalclase);
        return this.apiService.execGetQueryJson(`${tipdoc}/clases/${clase}/codigos`);
    }
    /**********************************/

    // *************************** clases y codigos ************

    eliminar_clase(tipdoc: number, clase: number, moneda: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_eliminar);
        return this.apiService.executeDeleteJson(`${tipdoc}/clase/${clase}/${moneda}`);
    }

    obtener_clase(tipdoc: number, clase: number, moneda: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_eliminar);
        return this.apiService.execGetQueryJson(`${tipdoc}/clase/${clase}/${moneda}`);
    }

    

    clases_insertar(tipdoc: number, data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_insertar + tipdoc + '/clases');
        return this.apiService.executePostJson(data).pipe();
    }

    clases_actualizar(tipdoc: number, data: iObjDocCobranza): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_actualizar + tipdoc + '/clases');
        return this.apiService.executePutJson(data).pipe();
    }

    clases_eliminar(tipdoc: number, clase: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_eliminar);
        return this.apiService.executeDeleteJson(`${tipdoc}/clases/${clase}`);
    }

    clases_codigo_eliminar(tipdoc: number, clase: number, codigo: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_eliminar);
        return this.apiService.executeDeleteJson(`${tipdoc}/clases/${clase}/codigos/${codigo}`);
    }


    ////////////// MANTENIMIENTO CLASES GENERICAS Y CODIGO ////////////////////////

    obtener_clases_ClaseGenerica(tipdoc: number, descri: any, limit : any , offset :any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_eliminar+`${tipdoc}/clases?`);
        return this.apiService.execGetQueryJson(`descri=${descri}&limit=${limit}&offset=${offset}`);
    }

    insertar_clases_ClaseGenerica(tipdoc: number, data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_insertar + tipdoc + '/clases');
        return this.apiService.executePostJson(data).pipe();
    }

    actualizar_clases_ClaseGenerica(tipdoc: number, data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_insertar + tipdoc + '/clases');
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar_clase_ClaseGenerica(tipdoc: number, clase: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_eliminar);
        return this.apiService.executeDeleteJson(`${tipdoc}/clases/${clase}`);
    }

    obtener_codigos_ClaseGenerica(tipdoc: number, clase: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_eliminar+`${tipdoc}/clases/${clase}/codigos`);
        return this.apiService.execGetQueryJson(``);
    }

    eliminar_codigos_ClaseGenerica(tipdoc: number, clase: number,codigos : any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.documentoscobranza_eliminar);
        return this.apiService.executeDeleteJson(`${tipdoc}/clases/${clase}/codigos/${codigos}`);
    }

} 